import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useLanguageRemovalPreview = (projectId, languageId, enabled) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(
    [
      "project",
      projectId?.toString(),
      "language",
      languageId?.toString(),
      "removal-preview",
    ],
    async () => {
      const { data } = await fetchContext.authAxios.get(
        `/projects/${projectId}/languages/${languageId}/removal-preview`
      );
      return data;
    },
    {
      enabled: Boolean(enabled && projectId != null && languageId != null),
      retry: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
